import { render, staticRenderFns } from "./AuditLogsReport.vue?vue&type=template&id=71dd3000&scoped=true"
import script from "./AuditLogsReport.vue?vue&type=script&lang=js"
export * from "./AuditLogsReport.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71dd3000",
  null
  
)

export default component.exports